// Hook pobierajacy liste koszykow oczekujacych na akceptacje (panel "Do akceptacji")

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';

export interface ICartToApproveListItem {
  id: number;
  name: string | null;
  status: number | null;
  create_datetime: string | null;
  status_change_date: string | null;
  currency: string | null;
  value_net: number | null;
  value_gross: number | null;
  user_id: number | null;
  client_id: number | null;
  approver_user_id: number | null;
  approval_notice: string | null;
}

export type IRequest = IPaginationRequest;

type IResponse = IPaginationResponse<ICartToApproveListItem>;

const getCartsToApprove = (params?: IRequest): Promise<IResponse> =>
  axios.get('/carts-to-approve', { params });

export const useGetCartsToApprove = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['carts-to-approve', params],
    () => getCartsToApprove(params),
    options
  );
